import PolyfilledResizeObserver from "resize-observer-polyfill";

export function patchResizeObserver() {
  window.ResizeObserver ||= PolyfilledResizeObserver;
}